import { START_PERIOD_PARAM_KEY, END_PERIOD_PARAM_KEY, LASTNOBS_PARAM_KEY, LAST_N_PERIODS_PARAM_KEY } from "./params.mjs";
const DATAFLOW_ANNOTATIONS_PATH = [
  "data",
  "dataflows",
  0,
  "annotations"
];
const DEFAULT_ANNOT_TYPE = "DEFAULT";
const DEFAULT_LASTNOBS_VAL = "1";
const MICRODATA = "DRILLDOWN";
const NO_DISPLAY_ANNOT_TYPE = "NOT_DISPLAYED";
const START_PERIOD_ANNOT = "TIME_PERIOD_START";
const END_PERIOD_ANNOT = "TIME_PERIOD_END";
const LASTNOBS_ANNOT = "LASTNOBSERVATIONS";
const LAST_N_PERIODS = "LASTNPERIODS";
const DEFAULT_PARAMS = {
  [START_PERIOD_ANNOT]: START_PERIOD_PARAM_KEY,
  [END_PERIOD_ANNOT]: END_PERIOD_PARAM_KEY,
  [LASTNOBS_ANNOT]: LASTNOBS_PARAM_KEY,
  [LAST_N_PERIODS]: LAST_N_PERIODS_PARAM_KEY
};
const LAYOUT_ANNOTATIONS_TYPES = [
  "LAYOUT_ROW",
  "LAYOUT_COLUMN",
  "LAYOUT_ROW_SECTION"
];
const LAYOUT_KEYS = {
  LAYOUT_COLUMN: "header",
  LAYOUT_ROW: "rows",
  LAYOUT_ROW_SECTION: "sections"
};
export {
  DATAFLOW_ANNOTATIONS_PATH,
  DEFAULT_ANNOT_TYPE,
  DEFAULT_LASTNOBS_VAL,
  DEFAULT_PARAMS,
  END_PERIOD_ANNOT,
  LASTNOBS_ANNOT,
  LAST_N_PERIODS,
  LAYOUT_ANNOTATIONS_TYPES,
  LAYOUT_KEYS,
  MICRODATA,
  NO_DISPLAY_ANNOT_TYPE,
  START_PERIOD_ANNOT
};
